export const Kick = ({ width = '25', height = '25' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_19960)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.544922 0.844482H7.90529V4.74078H10.3587V2.79263H12.8122V0.844482H20.1726V6.68893H17.7191V8.63706H15.2657V10.5852H17.7191V12.5334H20.1726V18.3778H12.8122V16.4297H10.3587V14.4815H7.90529V18.3778H0.544922V0.844482Z"
          fill="#53FC18"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_19960">
          <rect
            width="20.4556"
            height="17.5333"
            fill="white"
            transform="translate(0.544922 0.844482)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
